<div class="container mb-5">
    <form [formGroup]="userForm" (submit)="submit()" class="formulaire">
        <h5 class="text-center">Créer un compte</h5>
        <div class="row mb-2">
            <input class="forminput" type="email" formControlName="email" placeholder="Email" >
        </div>
        <div *ngIf="userForm.controls['email'].invalid && (userForm.controls['email'].dirty || userForm.controls['email'].touched)" class="alert">
            <label *ngIf="userForm.controls['email'].errors.required || userForm.controls['email'].hasError('email')" class="text-danger">
                ⚠️ Entrer une adresse mail valide
            </label>
        </div>
        <div class="row mb-2">
            <input class="forminput" type="text" formControlName="username" placeholder="Nom d'utilisateur">
        </div>
        <div *ngIf="userForm.controls['username'].invalid && (userForm.controls['username'].dirty || userForm.controls['username'].touched)" class="alert">
            <label *ngIf="userForm.controls['username'].errors.required || userForm.controls['username'].hasError('minlength')" class="text-danger">
                ⚠️ Entrer un nom d'utilisateur, il doit comprendre au minimum 5 caractères.
            </label>
        </div>
        <div class="row mb-2">
            <input class="forminput" type="password" formControlName="password" placeholder="Mot de passe">
        </div>
        <div *ngIf="userForm.controls['password'].invalid && (userForm.controls['password'].dirty || userForm.controls['password'].touched)" class="alert">
            <label
            class="text-danger"
            *ngIf="userForm.controls['password'].hasError('hasNumber') 
            ||userForm.controls['password'].hasError('hasCapitalCase')
            ||userForm.controls['password'].hasError('required')
            ||userForm.controls['password'].hasError('hasSmallCase')
            ||userForm.controls['password'].hasError('minlenght')"
            >
            ⚠️ Le mot de passe doit comporter au minimum 8 caractères, dont au moins une majuscule et une minuscule et un chiffre. 
            </label>
        </div>
        <div class="row mb-2">
            <input class="forminput" type="password" formControlName="confirmPassword" placeholder=" Confirmer mot de passe">
        </div>
        <div *ngIf="userForm.controls['confirmPassword'].invalid && (userForm.controls['confirmPassword'].dirty || userForm.controls['confirmPassword'].touched)" class="alert">
            <label  class="text-danger">
                ⚠️ Entrer le même mot de passe que précédement.
            </label>
        </div>
        <div class="row mb-2">
            <button class="btnsubmit" type="submit" [disabled]="!userForm.valid">Créer mon compte</button>
        </div>
        <div class="row mb-2" *ngIf="emailSubmit">
            <p *ngIf="emailsend"> Un email de confirmation vous a été envoyé,
                vous pouvez quitter cette page.
            </p>
            <p *ngIf="!emailsend">⚠️ Une erreur est survenue veuillez verifié l'adresse email</p>
        </div>
    </form>
</div>

